import CustomTooltip from '@/components/tooltips/CustomTooltip';
import useClickOutside from '@/hooks/useClickOutside';
import type { ReactNode } from 'react';
import { useState } from 'react';

const DEFAULT_TOOLTIP_CONTENT = (
  <>
    Includes <strong>all audio podcast apps or websites</strong> listeners use to play your content
    (Spotify, Apple Podcasts, Castbox, Amazon Music, Pocket Casts, etc.)
  </>
);

interface PodcastPlayersTooltipContentProps {
  content?: ReactNode;
}

const TooltipContent = ({ content }: { content: ReactNode }) => (
  <div className="p-2 flex items-center justify-left">
    <span className="text-sm">{content}</span>
  </div>
);

export const PodcastPlayersTooltipContent = ({ content = DEFAULT_TOOLTIP_CONTENT }: PodcastPlayersTooltipContentProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const popoverRef = useClickOutside<HTMLDivElement>(() => setIsTooltipOpen(false), {
    excludeSelector: 'a',
  });
  return (
    <div
      onMouseOver={() => setIsTooltipOpen(true)}
      onMouseLeave={() => setIsTooltipOpen(false)}
      className="flex flex-row w-auto items-center"
      ref={popoverRef}
    >
      ....
      <CustomTooltip
        popoverRef={popoverRef}
        placement="bottom"
        isOpen={isTooltipOpen}
        zIndex={50}
        className="bg-[#FAFAFA] text-DarkGrey shadow-lg"
      >
        <TooltipContent content={content} />
      </CustomTooltip>
    </div>
  );
};
